import React, { useEffect } from "react";
import elevateYourEnergy from "../../../main/assets/images/Images/EnergyAndUtilities/energy.png";
import energybanner from "../../../main/assets/images/Images/EnergyAndUtilities/energy_banner.png";
import energyimg3 from "../../../main/assets/images/Images/EnergyAndUtilities/energy_img_3.png";
import EnergyimgMobile from "../../../main/assets/images/Images/EnergyAndUtilities/Energy_img_1.png";
import energyimg2Mobile from "../../../main/assets/images/Images/EnergyAndUtilities/Energy_img_2.png";
import energyslider3 from "../../../main/assets/images/Images/EnergyAndUtilities/energy_slider_3.png";
import energyslider2 from "../../../main/assets/images/Images/EnergyAndUtilities/energy_slider_2.png";
import energyslider1 from "../../../main/assets/images/Images/EnergyAndUtilities/energy_slider_1.png";
import energyUtilitiesBanner from "../../../main/assets/images/Images/EnergyAndUtilities/energy-and-utilities-banner.png";
import smartGrid from "../../../main/assets/images/Images/EnergyAndUtilities/smart-grid-management1.png";
import waterUtilization from "../../../main/assets/images/Images/EnergyAndUtilities/water-utilization-predictions1.png";
import energyConsumption from "../../../main/assets/images/Images/EnergyAndUtilities/Layer_1 (1).png";
import enhancedResource from "../../../main/assets/images/Icons/EnergyAndUtilities/enhanced.svg";
import gridOptimization from "../../../main/assets/images/Icons/EnergyAndUtilities/optimization.svg";
import Group1 from "../../../main/assets/images/Icons/EnergyAndUtilities/group1.png";
import Group2 from "../../../main/assets/images/Icons/EnergyAndUtilities/group2.png";
import Group3 from "../../../main/assets/images/Icons/EnergyAndUtilities/group3.png";
import Group4 from "../../../main/assets/images/Icons/EnergyAndUtilities/group4.png";
import operationalEfficiency from "../../../main/assets/images/Icons/EnergyAndUtilities/operationalenergy.svg";
import predictiveMaintenance from "../../../main/assets/images/Images/EnergyAndUtilities/c.png";
import strategicDecision from "../../../main/assets/images/Icons/EnergyAndUtilities/strategic.svg";
import sustainableResource from "../../../main/assets/images/Icons/EnergyAndUtilities/management.svg";
import { Button } from "main/components/ui-components/Button";
import { MainPageHeader, SectionCard } from "main/components";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";

const featureEnergyAndUtilities = [
  {
    image: gridOptimization,
    whiteIcon: Group1,
    title: "Grid Optimization",
    subTitle:
      "Harness real-time data to balance supply and demand, ensuring grid reliability.",
  },
  {
    image: predictiveMaintenance,
    whiteIcon: Group2,
    title: "Predictive Maintenance",
    subTitle:
      "Anticipate equipment failures and schedule timely maintenance, minimizing downtime.",
  },
  {
    image: energyConsumption,
    whiteIcon: Group3,
    title: "Energy Consumption Forecasting",
    subTitle:
      "Predict spikes in energy demand, enabling efficient resource allocation.",
  },
  {
    image: sustainableResource,
    whiteIcon: Group4,
    title: "Sustainable Resource Management",
    subTitle:
      "Efficiently manage and allocate renewable energy resources based on AI-driven forecasts.",
  },
];

const realWorldUseCases = [
  {
    image: smartGrid,
    mobileImage: EnergyimgMobile,
    title: "Smart Grid Management",
    subTitle:
      "Optimize grid operations, drastically reducing outages and improving service quality.",
  },
  {
    image: waterUtilization,
    mobileImage: energyimg2Mobile,
    title: "Water Utilization Predictions",
    subTitle:
      "Predict water consumption trends, aiding in conservation efforts and optimal distribution.",
  },
];

const benefits = [
  {
    image: operationalEfficiency,
    mobileImage: energyslider1,
    title: "Operational Efficiency",
    subTitle:
      "Automate and streamline operations, from energy generation to distribution, using data-driven insights.",
  },
  {
    image: enhancedResource,
    mobileImage: energyslider2,
    title: "Enhanced Resource Allocation",
    subTitle:
      "Optimise patient care processes for efficiency and satisfaction, from admissions to supply chain management.",
  },
  {
    image: strategicDecision,
    mobileImage: energyslider3,
    title: "Strategic Decision-making",
    subTitle:
      "Leverage AI-driven data to make informed decisions about infrastructure investments, resource allocation, and sustainability initiatives.",
  },
];

export default function EnergyUtilities() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section>
        <MainPageHeader
          backgroundImage={energyUtilitiesBanner}
          mobilebgImage={energybanner}
          heading={"Energy and Utilities"}
          descriptionClass="text-white-color mb-3"
          description={`At Yantr.ai, we revolutionize the Energy and Utilities sector with AI algorithms for predictive maintenance, optimized route planning, and resource allocation. This reduces downtime and costs while improving reliability and customer satisfaction.`}
          buttonGroup={
            <>
              <div className="d-block d-md-none">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                    className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
              <div className="d-none d-md-block">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                    className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
            </>
          }
        />
      </section>
      <div className="container-fluid d-block  d-md-none">
        {/* mobile */}
        <section className="container-fluid  py-60 d-flex flex-column align-items-center ">
          <p className="dark-header fonts-800 font-30 mb-25 px-25 line-35 font-family-roboto text-align-center para-heading">
            Features Tailored for Energy and Utilities
          </p>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper customSwiper"
          >
            {featureEnergyAndUtilities.map((val, index) => (
              <SwiperSlide className="p-10">
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <Col key={index}>
                    <SectionCardMobile
                      classname="cards"
                      title={val.title}
                      icon={val.image}
                      whiteIcon={val.whiteIcon}
                      desc={val.subTitle}
                    />
                  </Col>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </div>
      <div className=" container d-none d-md-block">
        {" "}
        {/* website */}
        <section className="container py-60 d-flex flex-column align-items-center ">
          <p className="dark-header fonts-800 font-30 mb-25 line-35 font-family-roboto text-align-center para-heading">
            Features Tailored for Energy and Utilities
          </p>
          <div className="row cardsection px-mob-140">
            {featureEnergyAndUtilities.map((item: any, index: any) => {
              return (
                <div className="col-md-6 col-sm-12 col-lg-3 p-10">
                  <div className="" key={index}>
                    <div
                      className={`tcard-container d-flex flex-column py-20 radius-10 justify-content-center border border-1`}
                    >
                      <div className="image-container">
                        <img
                          className="tfront-image mx-5 my-3 mt-5"
                          src={item?.image}
                          alt="background will be here"
                        />
                        <img
                          className="tback-image mx-5 my-3"
                          src={item?.whiteIcon}
                          alt="background will be here"
                        />
                      </div>
                      <div className="card-body">
                        <p
                          className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-24 line-26 pb-2`}
                          style={{ color: "#3D1187" }}
                        >
                          {item?.title}
                        </p>
                        <p
                          className="px-3 tcard-desc text-center text-white-color fonts-400 font-18 line-20 font-family-roboto"
                          style={{ color: "#3D1187" }}
                        >
                          {item?.subTitle}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <section className="py-60 footer d-flex font-family-roboto flex-column align-items-center">
        <p className="text-white-color fonts-800 font-30 mb-50 text-align-center line-35 font-family-roboto realworld">
          Real World Use Cases
        </p>

        <div className="row w-85 flex-gap-20 justify-content-between">
          {realWorldUseCases.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className="real-world-view card-container1 flex-column w-48 mobile-cards-width d-flex px-16"
              >
                {/* Mobile View */}
                <div className="d-block d-md-none">
                  <img
                    src={item?.mobileImage}
                    className="w-100 h-100"
                    alt="background will be here"
                  />
                </div>
                {/* website */}
                <div className="d-none d-md-block">
                  <img
                    src={item?.image}
                    className="w-100 h-100"
                    alt="background will be here"
                  />
                </div>
                <p className="text-white-color font-family-roboto fonts-800 font-20 line-23 mt-3">
                  {item?.title}
                </p>
                <p className="text-white-color font-family-roboto fonts-400 font-16 line-20 mt-2  footer-subcontent2">
                  {item?.subTitle}
                </p>

                <div className="d-flex align-items-end h-100 mt-20 mb-10">
                  <Link to={"/contact-us"}>
                    <div className="d-none d-md-block">
                      {/* website */}
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-10"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                    {/* Mobile View */}
                    <div className="d-block d-md-none pt-30">
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-6"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      {/* mobile */}
      <div className="container-fluid d-block d-md-none">
        <section className="container-fluid py-40 d-flex font-family-roboto flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 font-family-roboto mb-15 line-35 text-align-center mobile-contactus-heading">
            Benefits
          </p>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper customSwiper"
          >
            {benefits.map((item: any, index: any) => (
              <div className="col-md-12 col-sm-12 col-lg-12">
                <div className="col">
                  <SwiperSlide className="p-10">
                    <div
                      key={index}
                      className="cards m-benefits-view flex-column d-flex align-items-center p-10"
                    >
                      <img
                        className="w-100"
                        src={item?.mobileImage}
                        alt="background will be here"
                      />
                      <div className="pt-2 d-flex flex-column align-items-center">
                        <p className="text-black-10 fonts-800 font-20 px-10 font-family-roboto line-24 align-items-center">
                          {item?.title}
                        </p>
                        <p className="text-grey fonts-400 font-16 mt-2 text-align-center line-20 font-family-roboto footer-subcontent2">
                          {item?.subTitle}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                </div>
              </div>
            ))}
          </Swiper>
        </section>
      </div>
      {/* Website */}
      <div className="d-none d-md-block">
        <section className="container py-60 d-flex font-family-roboto flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 font-family-roboto mb-40 line-35 text-align-center mobile-contactus-heading">
            Benefits
          </p>
          <div className="row justify-content-between px-70 px-mob-140">
            {benefits.map((item: any, index: any) => {
              return (
                <div
                  key={index}
                  className={`col-md-6 col-sm-12 col-lg-6 flex-gap-10 benefits-view flex-column w-49 mobile-cards-width ${
                    index === 2 && "col-lg-12 col-md-6 col-sm-12 w-100 mt-4"
                  }`}
                >
                  <img
                    src={item?.image}
                    alt="background will be here"
                    className="mt-10 w-100 px-0"
                  />
                  <div className="mt-40 mb-40 d-flex flex-column align-items-center">
                    <p className="text-black-10 fonts-800 font-20 font-family-roboto text-align-center line-24">
                      {item?.title}
                    </p>
                    <p className="text-grey fonts-400 font-16 mt-2 text-align-center line-20 font-family-roboto">
                      {item?.subTitle}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <div className="mx-20">
        <div className="radius-20 footer d-block  d-md-none">
          {/* mobile */}
          <section
            className="mb-40 py-4 py-md-0 radius-20"
            style={{
              backgroundImage: `url(${energyimg3})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              //height:"200px",
            }}
          >
            <div className="row py-0 py-md-5">
              <div className="col-lg-6 col-md-12"></div>
              <div className="col-lg-6 col-md-12 px-5 pt-400">
                <p className="text-white-color fonts-800 font-20 line-23 mb-10 pt-20 font-family-condensed">
                  Elevate Your Energy Management with Yantr.ai
                </p>
                <p className="text-white-color fonts-400 font-13 font-family-condensed line-15 mb-30 ">
                  Embrace the future of energy and utilities with dynamic
                  insights and unparalleled optimization solutions. Delve into
                  Yantr.ai's energy revolution.
                </p>
                <div className="pb-40">
                  <Link to={"/contact-us"}>
                    <Button
                      textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                      className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                      text="Contact Us"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="container d-none d-md-block">
          {/* Website */}
          <section
            className="mb-60 py-3 py-md-0 radius-20"
            style={{
              backgroundImage: `url(${elevateYourEnergy})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "350px",
            }}
          >
            <div className="row py-0 py-md-5">
              <div className="col-lg-6 col-md-12"></div>
              <div className="col-lg-6 col-md-12 px-5 p-20">
                <p className="text-white-color fonts-700 font-32 line-37 mb-10 pt-0 font-family-condensed mobile-contactus-heading">
                  Elevate Your Energy Management with Yantr.ai
                </p>
                <p className="text-white-color fonts-400 font-20 font-family-condensed line-23 mb-10 mobile-contactus-subheading">
                  Embrace the future of energy and utilities with dynamic
                  insights and unparalleled optimization solutions. Delve into
                  Yantr.ai's energy revolution.
                </p>
                <Link to={"/contact-us"}>
                  <Button
                    className="py-12 px-4 font-16 fonts-500 text-white-color font-family-roboto-flex"
                    onClick={() => {}}
                  >
                    Contact Us
                  </Button>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
